import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import {
  getRequest,
  postRequest,
//   getRequest1,
//   getRequest2,
//   postRequest1,
//   postRequest2,
//   postRequest3,
//   postRequest4,
//   uploadPostRequest,
//   fetchcampaign,
} from "./index";
const getKeyCloakToken = () => {
    let url = URL.KEYCLOAK_TOKEN;
    return getRequest(url, ActionTypes.LOGIN);
  };
const keyCloakLogout= () => {
    return getRequest(URL.KEYCLOAK_LOGOUT, ActionTypes.KEYCLOAK_LOGOUT);
  };
  const fetchKeycloakUserId = (payload) => {
    return postRequest(
      URL.FETCH_KEYCLOAK_USERID,
      payload,
      ActionTypes.FETCH_KEYCLOAK_USERID
    );
  };
const sessionExpired=(flag)=>{
    return {
      type: "SESSION_EXPIRED",
      payload: flag,
    };
  }
  export {getKeyCloakToken,keyCloakLogout,fetchKeycloakUserId,sessionExpired};